import { render, staticRenderFns } from "./ToBeDelivered.vue?vue&type=template&id=02ddc703&"
import script from "./ToBeDelivered.vue?vue&type=script&lang=ts&"
export * from "./ToBeDelivered.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports